import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=53545e76&scoped=true"
import script from "./ServiceCard.vue?vue&type=script&lang=js"
export * from "./ServiceCard.vue?vue&type=script&lang=js"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=53545e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53545e76",
  null
  
)

export default component.exports